import { Injectable } from '@angular/core';
import { SessionService as SessionServiceV1 } from '../../../shared/services/session.service';
import { ContainersService } from 'src/app/shared/services/containers.service';
import { PoliciesService } from 'src/app/shared/services/policies.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService extends SessionServiceV1 {

  constructor(
    containersService: ContainersService,
    policiesService: PoliciesService
  ) {
    super(containersService, policiesService);
  }
}